import { useConfiguratorDomain } from "@/configurator/domain/hooks/useConfiguratorDomain";

export type ModelBadgeComponent = {
  logoSrc: string | undefined;
  logoAlt: string;
};

export function useModelBadgeComponent(): ModelBadgeComponent {
  const { brand } = useConfiguratorDomain();
  return { logoSrc: brand.logoSrc, logoAlt: brand.logoAlt ?? "" };
}
